var map = {
	"./b.png": 9076,
	"./buld.jpg": 8543,
	"./cwoc.png": 9569,
	"./efi.png": 5690,
	"./flutter.png": 843,
	"./gdg.png": 7229,
	"./github.png": 449,
	"./googleAssistant.jpg": 700,
	"./google_logo.png": 5927,
	"./gtu.png": 4560,
	"./hackathon1.svg": 2781,
	"./harikrushn.jpg": 149,
	"./iit.png": 9268,
	"./ino.png": 6380,
	"./localguide.gif": 388,
	"./localguide.png": 9908,
	"./miguel.jpg": 6071,
	"./mlh-logo.png": 341,
	"./mlh-logo.svg": 6535,
	"./mlh.png": 4228,
	"./mongo.png": 7067,
	"./nightowls.jpg": 1612,
	"./postman.jpg": 5268,
	"./postman.png": 4097,
	"./skillenza.png": 6433,
	"./ssec.png": 1834,
	"./ssgandhy.png": 4501,
	"./valora.jpg": 6580,
	"./wrighter.jpg": 7039
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1106;